// hooks/useBusinessForm.ts
import { useState, useEffect } from "react";
import { ProfileData } from "../types/profile";

// Complete form data interface matching BusinessForm requirements
interface BusinessFormData {
  business_name: string;
  _id: { $oid: string };
  address_line_1: string;
  date_of_birth: string;
  name: string;
  phone_number: string;
  user_name: string;
  filename: string;
  organization_name: string;
  email_id: string;
  business_location: string;
  org_arabic_name: string;
  time_zone: number;
  state: string;
  postal_code: string;
  country: string;
  business_type: string;
}

export const useBusinessForm = (profileData: ProfileData | null) => {
  const [formData, setFormData] = useState<BusinessFormData>({
    business_name: "",
    _id: { $oid: "" },
    address_line_1: "",
    date_of_birth: "",
    name: "",
    phone_number: "",
    user_name: "",
    filename: "",
    organization_name: "",
    email_id: "",
    business_location: "",
    org_arabic_name: "",
    time_zone: 0,
    state: "",
    postal_code: "",
    country: "",
    business_type: "",
  });

  useEffect(() => {
    if (profileData) {
      setFormData({
        business_name: profileData.business_name || "",
        _id: profileData._id || { $oid: "" },
        address_line_1: profileData.address_line_1 || "",
        date_of_birth: profileData.date_of_birth || "",
        name: profileData.name || "",
        phone_number: profileData.phone_number || "",
        user_name: profileData.user_name || "",
        filename: profileData.filename || "",
        organization_name: profileData.organization_name || "",
        email_id: profileData.email_id || "",
        business_location: profileData.business_location || "",
        org_arabic_name: profileData.org_arabic_name || "",
        time_zone: profileData.time_zone || 0,
        state: profileData.state || "",
        postal_code: profileData.postal_code || "",
        country: profileData.country || "",
        business_type: profileData.business_type || "",
      });
    }
  }, [profileData]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;

    if (name === "phone_number") {
      // Allow only digits and max 8 length
      const numericValue = value.replace(/\D/g, "").slice(0, 8);
      setFormData((prev) => ({
        ...prev,
        phone_number: numericValue,
      }));
      return;
    }

    setFormData((prev) => ({
      ...prev,
      [name]: name === "time_zone" ? Number(value) : value,
    }));
  };

  return { formData, handleChange,setFormData };
};
